interface Array<T>
{
    select(expr: (item: T) => any): any[];
    where(expr: (item: T, index?: number) => boolean): T[];
    first(): T;
    last(): T;
    remove(item: T): void;
    removeAt(expr: (item: T) => boolean): void;
    any(expr: (item: T) => boolean): boolean;
    contains(item: T): boolean;
    distinct(): T[];
}

if (typeof Array.prototype.select !== 'function')
{
    Array.prototype.select = function (expr: (item) => any)
    {
        return this.map(expr);
    };
}

if (typeof Array.prototype.where !== 'function')
{
    Array.prototype.where = function (expr: (item, index) => boolean)
    {
        var result: any[] = [];
        this.some((elem, index) =>
        {
            if (expr.call(this, elem, index))
            {
                result.push(elem);
                //return true;
            }
            else
            {
                return false;
            }
        });

        return result;
    };
}

if (typeof Array.prototype.any !== 'function')
{
    Array.prototype.any = function (expr: (item) => boolean): boolean
    {
        return this.some((elem, index) => expr.call(this, elem));
    };
}

if (typeof Array.prototype.first !== 'function')
{
    Array.prototype.first = function ()
    {
        var array: any[] = this;
        if (array.length > 0)
        {
            return array[0];
        }
        else
        {
            return null;
        }
    };
}

if (typeof Array.prototype.last !== 'function')
{
    Array.prototype.last = function ()
    {
        var array: any[] = this;
        if (array.length > 0)
        {
            return array[array.length - 1];
        }
        else
        {
            return null;
        }
    };
}

if (typeof Array.prototype.removeAt !== 'function')
{
    Array.prototype.removeAt = function (expr: (item) => boolean)
    {
        var array: any[] = this;
        var matched = array.where(expr);
        if (array.length > 0)
        {
            for (let item of matched)
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    };
}

if (typeof Array.prototype.remove !== 'function')
{
    Array.prototype.remove = function (item)
    {
        var array: any[] = this;
        array.splice(array.indexOf(item), 1);
    };
}

if (typeof Array.prototype.contains !== 'function')
{
    Array.prototype.contains = function (item): boolean
    {
        var array: any[] = this;
        return array.indexOf(item) >= 0;
    };
}

if (typeof Array.prototype.distinct !== 'function')
{
    Array.prototype.distinct = function ()
    {
        var prims = { "boolean": {}, "number": {}, "string": {} }, objs = [];

        return this.filter(function (item)
        {
            var type = typeof item;
            if (type in prims)
                return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
            else
                return objs.indexOf(item) >= 0 ? false : objs.push(item);
        });
    };
}